module.exports = __webpack_public_path__ + "static/media/post.c65c4bff.png";